import React, { useCallback, useMemo } from 'react';

import { Input } from '@appcharge/shared-ui';

import { SchemaFormat } from '../../../integration-test-modal.types';
import { schemaUtils } from '../../../integration-test-modal.utils';
import { ITextFieldProps } from '../schema-form-field.types';

export const TextField: React.FC<ITextFieldProps> = ({
  name,
  path,
  property,
  value,
  onChange,
  required
}) => {
  const fieldLabel = useMemo(
    () => schemaUtils.formatFieldLabel(name, property.title),
    [property.title, name]
  );

  const isEmailField = useMemo(
    () => property.format === SchemaFormat.EMAIL,
    [property.format]
  );

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(path, e.target.value);
    },
    [path, onChange]
  );

  const placeholderValue = useMemo(() => {
    if (property.default === undefined) {
      return undefined;
    }
    return String(property.default);
  }, [property.default]);

  const inputType = useMemo(() => {
    if (isEmailField) {
      return 'email';
    }
    return 'text';
  }, [isEmailField]);

  return (
    <Input
      type={inputType}
      label={fieldLabel}
      isRequired={required}
      description={property.description}
      value={String(value ?? '')}
      onChange={handleInputChange}
      placeholder={placeholderValue}
      minLength={property.minLength}
      maxLength={property.maxLength}
      readOnly={property.readOnly}
      required={required}
      disabled={property.readOnly}
    />
  );
};
